import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { requestOpenMessagesChannel } from '../../redux/atlasai/actions'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { markAsRead } from '../../redux/notification/actions'
import { isLoading, lastNotifications } from '../../redux/notification/selectors'
import NotificationPane, { IProps } from './NotificationPane'

const selector = createStructuredSelector({
  isLoading,
  notifications: lastNotifications,
})
const actions = {
  markAsRead,
  requestOpenMessagesChannel,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(
  connector,
  NotificationPane,
)
